import {
  IFetchAssessmentListFailure,
  IFetchAssessmentListRequest,
  IFetchAssessmentListSuccess,
  IFetchAssessmentListSuccessPayload,
  IFetchEnrolledPatientSuccessPayload,
  IFetchIEnrolledPatientStateFailure,
  IFetchIEnrolledPatientStateRequest,
  IFetchIEnrolledPatientStateSuccess,
  IFetchIScreenedListStateFailure,
  IFetchIScreenedListStateRequest,
  IFetchIScreenedListStateSuccess,
  IFetchIUserPerformanceListStateFailure,
  IFetchIUserPerformanceListStateRequest,
  IFetchIUserPerformanceListStateSuccess,
  IFetchScreenedListSuccessPayload,
  IFetchSSReportViewRequest,
  IFetchSSReportViewSuccess,
  IFetchSSReportViewFailure,
  IFetchSSReportViewSuccessPayload,
  IFetchSKReportViewRequest,
  IFetchSKReportViewSuccess,
  IFetchSKReportViewFailure,
  IFetchSKReportViewSuccessPayload,
  IFetchSKDetailsListRequest,
  IFetchSKDetailsListSuccess,
  IFetchSKDetailsListFailure,
  IFetchSKDetailsListSuccessPayload,
  IFetchSKDetailsViewRequest,
  IFetchSKDetailsViewSuccess,
  IFetchSKDetailsViewFailure,
  IClearSKDetailsView,
  ISKDetailsView,
  IFetchUserPerformanceListSuccessPayload
} from '../report/types';
import * as REPORT_TYPES from './actionTypes';

export const fetchScreenedPatientListRequest = ({
  payload
}: Omit<IFetchIScreenedListStateRequest, 'type'>): IFetchIScreenedListStateRequest => ({
  type: REPORT_TYPES.FETCH_SCREENED_PATIENT_LIST_REQUEST,
  payload
});

export const fetchScreenedPatientListSuccess = (
  payload: IFetchScreenedListSuccessPayload
): IFetchIScreenedListStateSuccess => ({
  type: REPORT_TYPES.FETCH_SCREENED_PATIENT_SUCCESS,
  payload
});

export const fetchScreenedPatientListFailure = (error: Error): IFetchIScreenedListStateFailure => ({
  type: REPORT_TYPES.FETCH_SCREENED_PATIENT_FAILURE,
  error
});

export const fetchEnrolledPatientRequest = ({
  payload
}: Omit<IFetchIEnrolledPatientStateRequest, 'type'>): IFetchIEnrolledPatientStateRequest => ({
  type: REPORT_TYPES.FETCH_ENROLLED_PATIENT_REQUEST,
  payload
});

export const fetchEnrolledPatientSuccess = (
  payload: IFetchEnrolledPatientSuccessPayload
): IFetchIEnrolledPatientStateSuccess => ({
  type: REPORT_TYPES.FETCH_ENROLLED_PATIENT_SUCCESS,
  payload
});

export const fetchEnrolledPatientFailure = (error: Error): IFetchIEnrolledPatientStateFailure => ({
  type: REPORT_TYPES.FETCH_ENROLLED_PATIENT_FAILURE,
  error
});

export const fetchUserPerformanceListRequest = ({
  payload
}: Omit<IFetchIUserPerformanceListStateRequest, 'type'>): IFetchIUserPerformanceListStateRequest => ({
  type: REPORT_TYPES.FETCH_USER_PERFORMANCE_LIST_REQUEST,
  payload
});

export const fetchUserPerformanceListSuccess = (
  payload: IFetchUserPerformanceListSuccessPayload
): IFetchIUserPerformanceListStateSuccess => ({
  type: REPORT_TYPES.FETCH_USER_PERFORMANCE_LIST_SUCCESS,
  payload
});

export const fetchUserPerformanceListFailure = (error: Error): IFetchIUserPerformanceListStateFailure => ({
  type: REPORT_TYPES.FETCH_USER_PERFORMANCE_LIST_FAILURE,
  error
});

export const fetchAssessmentListRequest = ({
  payload
}: Omit<IFetchAssessmentListRequest, 'type'>): IFetchAssessmentListRequest => ({
  type: REPORT_TYPES.FETCH_ASSESSMENT_LIST_REQUEST,
  payload
});

export const fetchAssessmentListSuccess = (
  payload: IFetchAssessmentListSuccessPayload
): IFetchAssessmentListSuccess => ({
  type: REPORT_TYPES.FETCH_ASSESSMENT_LIST_SUCCESS,
  payload
});

export const fetchAssessmentListFailure = (error: Error): IFetchAssessmentListFailure => ({
  type: REPORT_TYPES.FETCH_ASSESSMENT_LIST_FAILURE,
  error
});

export const fetchSSReportViewRequest = ({
  payload,
  failureCb
}: Omit<IFetchSSReportViewRequest, 'type'>): IFetchSSReportViewRequest => ({
  type: REPORT_TYPES.FETCH_SS_REPORT_VIEW_REQUEST,
  payload,
  failureCb
});

export const fetchSSReportViewSuccess = (
  payload: IFetchSSReportViewSuccessPayload
): IFetchSSReportViewSuccess => ({
  type: REPORT_TYPES.FETCH_SS_REPORT_VIEW_SUCCESS,
  payload
});

export const fetchSSReportViewFailure = (error: Error): IFetchSSReportViewFailure => ({
  type: REPORT_TYPES.FETCH_SS_REPORT_VIEW_FAILURE,
  error
});

export const fetchSKReportViewRequest = ({
  payload,
  failureCb
}: Omit<IFetchSKReportViewRequest, 'type'>): IFetchSKReportViewRequest => ({
  type: REPORT_TYPES.FETCH_SK_REPORT_VIEW_REQUEST,
  payload,
  failureCb
});

export const fetchSKReportViewSuccess = (
  payload: IFetchSKReportViewSuccessPayload
): IFetchSKReportViewSuccess => ({
  type: REPORT_TYPES.FETCH_SK_REPORT_VIEW_SUCCESS,
  payload
});

export const fetchSKReportViewFailure = (error: Error): IFetchSKReportViewFailure => ({
  type: REPORT_TYPES.FETCH_SK_REPORT_VIEW_FAILURE,
  error
});

export const fetchSKDetailsListRequest = ({
  payload,
  failureCb
}: Omit<IFetchSKDetailsListRequest, 'type'>): IFetchSKDetailsListRequest => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_LIST_REQUEST,
  payload,
  failureCb
});

export const fetchSKDetailsListSuccess = (
  payload: IFetchSKDetailsListSuccessPayload
): IFetchSKDetailsListSuccess => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_LIST_SUCCESS,
  payload
});

export const fetchSKDetailsListFailure = (error: Error): IFetchSKDetailsListFailure => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_LIST_FAILURE,
  error
});

export const fetchSKDetailsViewRequest = ({
  payload,
  failureCb
}: Omit<IFetchSKDetailsViewRequest, 'type'>): IFetchSKDetailsViewRequest => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_VIEW_REQUEST,
  payload,
  failureCb
});

export const fetchSKDetailsViewSuccess = (payload: ISKDetailsView): IFetchSKDetailsViewSuccess => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_VIEW_SUCCESS,
  payload
});

export const fetchSKDetailsViewFailure = (error: Error): IFetchSKDetailsViewFailure => ({
  type: REPORT_TYPES.FETCH_SK_DETAILS_VIEW_FAILURE,
  error
});

export const clearSKDetailsView = (): IClearSKDetailsView => ({
  type: REPORT_TYPES.CLEAR_SK_DETAILS_VIEW
});
